import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { _t } from '@hip/translations';
import { Toast } from '@realm-kf/halcyon-components-react';
import { actions as analyticsActions, AnalyticsEventMap, AnalyticsEvents, makeAnalyticsPayload, } from '../../core/analytics';
import { getError, getBooking } from '../../core/appointment';
import { AppointmentSummary } from '../../components/appointmentSummary/appointmentSummary';
import { Layout } from '../../components/layout';
import { useHeaderTranslations } from '../../hooks/useHeaderTranslations';
var AmendSuccess = function () {
    var dispatch = useDispatch();
    var appointmentId = useParams().appointmentId;
    var appointmentError = useSelector(getError);
    var booking = useSelector(getBooking);
    var _a = useHeaderTranslations(), title = _a.title, subtitle = _a.subtitle;
    useEffect(function () {
        if (booking) {
            dispatch(analyticsActions.sendAnalyticsEvent(makeAnalyticsPayload(AnalyticsEvents.AMEND_CONFIRMATION, "".concat(booking === null || booking === void 0 ? void 0 : booking.service_name, " ").concat(booking === null || booking === void 0 ? void 0 : booking.booking_type))));
        }
    }, [booking]);
    useEffect(function () {
        if (appointmentError) {
            dispatch(analyticsActions.sendAnalyticsEvent(makeAnalyticsPayload(AnalyticsEvents.AMEND_GENERIC_ERROR, AnalyticsEventMap[AnalyticsEvents.AMEND_CONFIRMATION].action)));
        }
    }, [appointmentError]);
    return (React.createElement(Layout, { title: title, subtitle: subtitle },
        React.createElement(AppointmentSummary, { appointmentId: appointmentId }),
        React.createElement(Toast, { content: _t('appointment_booking.common.sth_went_wrong'), fromTop: "0", isVisible: !!appointmentError, variant: "warning" })));
};
export { AmendSuccess };
